'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:travel:setGdata');
}

var _invoke = require('../invoke');

/**
 * 设置客户端大G埋点
 *
 *
 * 支持版本
 * + iTrip/6.9+
 *
 *
 * @memberof travel
 * @static
 * @name setGdata
 * @param {String} bigG
 * @return {Promise}
 * @example
 *  hbnb.travel.setGdata('bigG')
 *      .then(function(bigG) {
 *          bigG = {
 *              status: 1          //0: 失败；1:成功
 *          }
 *      });
 */
module.exports = function(bigG) {
    if (process.env.NODE_ENV !== 'production') {
        debug('bigG is %s', bigG);
    }
    bigG = bigG || '';

    var p = new Promise(function(resolve, reject) {
        _invoke('travel', 'set_g_data', {
            gdata: bigG,
            callback: function(bigG) {
                resolve(bigG);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/travel/set-g-data.js
// module id = 646
// module chunks = 0